/**
 * Organisation Constants
 * 
 * Central source of truth for all organisation-related enums,
 * defaults, and configuration. Extensible for future org types
 * (Hospital, Lab, etc.) without code changes elsewhere.
 */

// ── Organisation Types ───────────────────────────────────────────────
// MVP: Only CLINIC is active. Hospital & Lab are future-ready.
export const ORGANISATION_TYPES = {
  CLINIC: 'CLINIC',
  HOSPITAL: 'HOSPITAL',
  OPD: 'OPD',
  LAB: 'LAB',
};

export const ORGANISATION_TYPE_LABELS = {
  [ORGANISATION_TYPES.CLINIC]: 'Clinic',
  [ORGANISATION_TYPES.HOSPITAL]: 'Hospital',
  [ORGANISATION_TYPES.OPD]: 'OPD',
  [ORGANISATION_TYPES.LAB]: 'Laboratory',
};

export const DEFAULT_ORGANISATION_TYPE = ORGANISATION_TYPES.CLINIC;

// ── Working Days ─────────────────────────────────────────────────────

export const WEEKDAYS = [
  { key: 'Mon', label: 'Mon' },
  { key: 'Tue', label: 'Tue' },
  { key: 'Wed', label: 'Wed' },
  { key: 'Thu', label: 'Thu' },
  { key: 'Fri', label: 'Fri' },
  { key: 'Sat', label: 'Sat' },
  { key: 'Sun', label: 'Sun' },
];

export const DEFAULT_WORKING_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// ── Indian States & Union Territories ────────────────────────────────

export const INDIAN_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  // Union Territories
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Jammu and Kashmir',
  'Ladakh',
  'Lakshadweep',
  'Puducherry',
];

// ── Defaults for Form ────────────────────────────────────────────────

export const DEFAULT_OPENING_TIME = '09:00';
export const DEFAULT_CLOSING_TIME = '18:00';

/**
 * Get type-specific field config for future extensibility.
 * When Hospital/Lab are added, this function can return
 * additional required fields per org type.
 *
 * @param {string} orgType - Organisation type key
 * @returns {Object} - Extra field configuration for that type
 */
export const getOrgTypeConfig = (orgType) => {
  const configs = {
    [ORGANISATION_TYPES.CLINIC]: {
      extraFields: [],
      label: ORGANISATION_TYPE_LABELS[ORGANISATION_TYPES.CLINIC],
    },
    [ORGANISATION_TYPES.HOSPITAL]: {
      extraFields: [], // Future: bed_count, departments, etc.
      label: ORGANISATION_TYPE_LABELS[ORGANISATION_TYPES.HOSPITAL],
    },
    [ORGANISATION_TYPES.LAB]: {
      extraFields: [], // Future: accreditation, test_categories, etc.
      label: ORGANISATION_TYPE_LABELS[ORGANISATION_TYPES.LAB],
    },
  };

  return configs[orgType] || configs[ORGANISATION_TYPES.CLINIC];
};
